const hostname = window.location.hostname;
const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.');

// Use the current hostname for local dev to avoid "localhost" vs "127.0.0.1" mismatches
export const API_BASE_URL = isLocalhost 
    ? `${window.location.protocol}//${hostname}/kasunSir/api`
    : 'https://kasunwalakumbura.com/api';

export const ASSET_BASE_URL = isLocalhost
    ? `${window.location.protocol}//${hostname}/kasunSir`
    : 'https://kasunwalakumbura.com';

export default API_BASE_URL;
